// Export all services
export * as authService from './auth'
// export { contentService } from './content'
// export { eventsService } from './events'

// Initialize auth from stored data when app starts
import { initializeAuth } from './auth'
initializeAuth()